export enum SearchStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  NONE = 'NONE',
}
